import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<button type=\"button\" class=\"ui tertiary button [&.ui.tertiary.button]:text-pink [&.ui.button]:[letter-spacing:0] [&.ui.tertiary.button]:!m-0\" ...attributes>\n  {{yield}}\n</button>", {
  moduleName: "ui-kit/components/link-button/index.hbs"
});